import classNames from 'classnames';
import React from 'react';
import styles from './index.module.scss';
interface Props {
  rank: number;
  score: number;
  renderLogo: () => JSX.Element;
  renderInfo: () => JSX.Element;
}
const supply = (number: number) => {
  if (number < 10) return `0${number}`;
  return number;
};
const RankItem: React.FC<Props> = ({ rank, score, renderInfo, renderLogo }) => {
  return (
    <div
      className={classNames(
        styles.container,
        rank < 4 && styles[`rank${rank}`]
      )}
    >
      <div className={styles.rank}>{rank > 3 && supply(rank)}</div>
      {renderLogo()}
      {renderInfo()}
      <div className={styles.score}>{score}</div>
    </div>
  );
};

export default RankItem;
